import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined'
import HistoryIcon from '@mui/icons-material/History'
import { useLocation, useParams } from 'react-router-dom'
import { useGetVendorDetailsById } from 'vendors/queries/useVendorQuery'
import Skeleton from '@mui/material/Skeleton'
import VendorManageNavigationItem from 'vendors/vendorManage/VendorManageNavigationItem'
import { useTranslation } from 'react-i18next'

type VendorManageProps = {
  drawerOpen: boolean
  toggleDrawer: () => void
  isWidescreen: boolean
}

const VendorManageNavigation: React.FC<VendorManageProps> = ({ drawerOpen, toggleDrawer, isWidescreen }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const { vendorId } = useParams<{ vendorId: string }>()

  const { data: vendorDetails } = useGetVendorDetailsById(vendorId ?? '')

  const baseurl = `/vendors/manage/${vendorId}`

  const navItems = [
    {
      primaryText: t('company-information'),
      secondaryText: t('basic-company-information-in-register'),
      to: '/information',
      icon: <SettingsOutlinedIcon />
    },
    {
      primaryText: t('contacts'),
      secondaryText: t('contacts-secondary-text'),
      to: '/contacts',
      icon: <GroupOutlinedIcon />
    },
    {
      primaryText: t('service-classifications'),
      secondaryText: t('services-secondary-text'),
      to: '/services',
      icon: <CleaningServicesIcon />
    },
    {
      primaryText: t('region-of-operation'),
      secondaryText: t('region-of-operation-secondary-text'),
      to: '/region',
      icon: <FmdGoodOutlinedIcon />
    },
    {
      primaryText: t('management-history'),
      secondaryText: t('management-history-secondary-text'),
      to: '/history',
      icon: <HistoryIcon />
    }
  ]

  return (
    <Drawer
      sx={{
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: isWidescreen ? 411 : 300,
          boxSizing: 'border-box'
        }
      }}
      open={drawerOpen}
      variant={isWidescreen ? 'permanent' : 'temporary'}
      anchor="left"
      onClose={toggleDrawer}
    >
      <Toolbar />
      <Box>
        <Typography variant="body1" sx={{ fontSize: 20, margin: 2, mt: 3, minHeight: 30 }}>
          {vendorDetails?.name ?? <Skeleton sx={{ width: '75%' }} />}
        </Typography>
        <List component="nav" aria-label="manage company tabs">
          <Divider />
          {navItems.map(({ to, ...rest }) => {
            const url = `${baseurl}${to}`
            return <VendorManageNavigationItem key={to} isSelected={location.pathname === url} to={url} {...rest} />
          })}
        </List>
      </Box>
    </Drawer>
  )
}

export default VendorManageNavigation
